module.exports = __webpack_public_path__ + "media/images/careers/fun-0c4c1bd60f8235f324967e80cc391e39.svg";